import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LiveTableStatus from './components/LiveTableStatus/LiveTableStatus';
import Login from './components/Login/Login';
import Registration from './components/Register/Registration';
import SystemUserDashboard from './components/SystemUserDashboard/SystemUserDashboard';
import SelectOutlate from './components/SelectOutlate/SelectOutlate';
import AccsDashboard from './components/Accounts/AccsDashboard';
import ReportsDashbord from './components/ReportsDashbord/ReportsDashbord';
import HoAccountDashbord from './components/HoAccountUser/HoAccountDashbord';
import SelectOutlateForHO from './SelectOutlateForHO/SelectOutlateForHO';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/NewRegistration" element={<Registration />} /> 
        {/* Use the /SystemUserDashboard path, making it a parent route */}
        <Route path="/SystemUserDashboard/*" element={<SystemUserDashboard />} />
        <Route path="/AccsDashboard/*" element={<AccsDashboard />} />
        <Route path="/HoAccDashbord/*" element={<HoAccountDashbord />} />
        <Route path="/ReportsDashboard/*" element={<ReportsDashbord />} />
        <Route path="/LiveTableStatus" element={<LiveTableStatus />} />
        <Route path="/selectOutlate" element={<SelectOutlate />} />
        <Route path="/selectOutlateForHO" element={<SelectOutlateForHO />} />
      

      </Routes>
    </BrowserRouter>
  );
}

export default App;
